import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Observable, finalize } from 'rxjs';

import { WorkTask, WorkTaskStatus } from '@shared/models';

import { BaseService } from '../base.service';
import { httpParams } from '../http-params.builder';
import { LoadersService } from '../loaders.service';

@Injectable({ providedIn: 'root' })
export class WorkTasksService extends BaseService {
  private readonly http = inject(HttpClient);
  private readonly loadersService = inject(LoadersService);

  getAll(loader: string, projectId?: string): Observable<WorkTask[]> {
    this.loadersService.show(loader);
    return this.http
      .get<WorkTask[]>(`${this.baseUrl}/work-tasks`, { params: httpParams().set('projectId', projectId).build() })
      .pipe(finalize(() => this.loadersService.hide(loader)));
  }

  save(workTask: WorkTask, loader: string): Observable<WorkTask> {
    this.loadersService.show(loader);
    const result = workTask.id
      ? this.http.put<WorkTask>(`${this.baseUrl}/work-tasks`, workTask)
      : this.http.post<WorkTask>(`${this.baseUrl}/work-tasks`, workTask);
    return result.pipe(finalize(() => this.loadersService.hide(loader)));
  }

  move(id: string, status: WorkTaskStatus, sortOrder: number, loader: string): Observable<WorkTask> {
    this.loadersService.show(loader);
    return this.http
      .put<WorkTask>(`${this.baseUrl}/work-tasks/move`, { id, status, sortOrder })
      .pipe(finalize(() => this.loadersService.hide(loader)));
  }

  delete(id: string, loader: string): Observable<void> {
    this.loadersService.show(loader);
    return this.http
      .delete<void>(`${this.baseUrl}/work-tasks/${id}`)
      .pipe(finalize(() => this.loadersService.hide(loader)));
  }
}
